import { Component, forwardRef, input, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator } from '@angular/forms';
import { UiSafeStaff } from 'src/app/api/commonInterfaces';
import { StaffService } from 'src/app/api/staff.service';
import { PreferencesService } from 'src/app/preferences.service';
import { IconService } from '../icon.service';
import { MultiSelectModule } from 'primeng/multiselect';

import { StaffDisplayPipe } from '../pipes/staff-display.pipe';
import { TagModule } from 'primeng/tag';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-staff-dropdown-multi',
    templateUrl: './staff-dropdown-multi.component.html',
    styleUrls: ['./staff-dropdown-multi.component.scss'],
    imports: [MultiSelectModule, ReactiveFormsModule, StaffDisplayPipe, TagModule, FontAwesomeModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StaffDropdownMultiComponent),
            multi: true
        }
    ],
})
export class StaffDropdownMultiComponent implements ControlValueAccessor, OnInit {
  
  value: UiSafeStaff[] | null = null
  onChange: any = () => { };
  onTouched: any = () => { };
  disabled = false;
  touched = false;

  form = new FormGroup({
    staff: new FormControl<UiSafeStaff[]>([])
  })

  private _options: UiSafeStaff[] = []
  @Input() set options(value: UiSafeStaff[]) {
    // Don't re-sort if the options already contain "(INACTIVE)" prefixes
    // This indicates they come from StaffV2Service which has already been properly sorted
    const hasInactiveStaff = value.some(staff => staff.first.includes('(INACTIVE)'));
    if (hasInactiveStaff) {
      this._options = value;
    } else {
      this._options = this.staffService.sortStaff(value, this.preferences.staffDisplay);
    }
  }

  get options(): UiSafeStaff[] {
    return this._options
  }

  virtualScroll = input(false)
  virtualScrollItemSize = input(38)
  loading = input(false)

  constructor(
    public icons: IconService,
    private staffService: StaffService,
    public preferences: PreferencesService
  ) {

  }

  ngOnInit():void {
    this.form.valueChanges.subscribe(changes => {
      this.value = changes.staff ? changes.staff : null
      this.onChange(this.value)
    })


  }

  writeValue(obj: any): void {
    this.value = obj
    this.form.controls.staff.setValue(obj)

  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
    isDisabled ? this.form.disable() : this.form.enable()
    
  }

  removeItem(staff: UiSafeStaff) {
    if (this.disabled) {
      return
    }
    this.markAsTouched()
    this.value = this.value?.filter(s => s.id !== staff.id) ?? []
    this.form.controls.staff.setValue(this.value)
    this.onChange(this.value)
  }

  valueChange() {
    this.markAsTouched()
    this.onChange(this.value)
  }

  onInputBlur() {
    this.markAsTouched()
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true
    }
  }

}
